import { render, staticRenderFns } from "./billing.vue?vue&type=template&id=28512306&scoped=true&"
import script from "./billing.js?vue&type=script&lang=js&"
export * from "./billing.js?vue&type=script&lang=js&"
import style0 from "./billing.css?vue&type=style&index=0&id=28512306&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28512306",
  null
  
)

export default component.exports